export enum SelectablePlan {
  Pro = "Pro",
  Starter = "Starter",
}
